import { useRef, useEffect } from "react";
import useStore from "../hooks/useStore";
import { Draggable } from "gsap/Draggable";
import { gsap } from "gsap";
gsap.registerPlugin(Draggable);

export default function PromptHistoryView() {
  const promptHistory = useStore((state) => state.promptHistory);
  const data = useStore((state) => state.data);
  const isInitialized = useStore((state) => state.isInitialized);
  const xray = useStore((state) => state.xray);
  const ref = useRef(null);

  if (promptHistory.length === 0 || !isInitialized) {
    return;
  }

  function getOpacity(i) {
    if (promptHistory.length === 1) {
      return 100;
    } else if (promptHistory.length >= 4) {
      return 100 - (3 - i) * 20;
    } else {
      return 100 - (2 - i) * 20;
    }
  }

  return (
    <div
      className="prompt-history-container"
      data-state={xray ? "xray" : "ui"}
      ref={ref}
    >
      <div className="history-viewport">
        {promptHistory.map((d, i) => {
          return (
            <div
              className="prompt-record"
              key={d.timestamp}
              style={{ opacity: getOpacity(i) }}
              data-state={d.src}
            >
              <span className="prompt-anchor">{d.anchor}</span>
              <span className="prompt-content">{d.prompt}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
